import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { IconClose } from '../icons';

const TopBanner = ({ header, content }) => {
  const [dismissed, setDismissed] = useState(true);
  const dismissTopBannerKey = 'dismissTopBanner';

  useEffect(() => {
    // show banner if user is coming from LoungeBuddy
    const showBanner = document.referrer.includes('loungebuddy');

    const dismissVal = window.localStorage.getItem(dismissTopBannerKey);

    if (!dismissVal && showBanner) {
      setDismissed(false); // Dismiss the banner if it was previously dismissed'
    }
  }, []);

  const handleDismiss = () => {
    window.localStorage.setItem(dismissTopBannerKey, 1);
    setDismissed(true);
  };

  if (dismissed) {
    return null; // Don't render the banner if dismissed
  }

  return (
    <div className="tw-top-amexHeaderHeight tw-z-20 tw-w-full tw-bg-gray-100 lg_tw-sticky lg_tw-animate-expand">
      <div className="tw-mx-auto tw-max-w-screen-x2l tw-px-4 md_tw-px-6 lg_tw-px-8 xl_tw-px-10">
        <div className="tw-flex tw-items-start">
          <div className="tw-w-fit tw-py-3">
            <div className="tw-body-xs-bold tw-mb-1 tw-text-gray-800 lg_tw-text-sm">
              {header}
            </div>
            <p className="tw-text-xs tw-text-gray-700 lg_tw-text-sm">
              {content}
            </p>
          </div>
          <button
            className="tw-h-10 tw-w-10 tw-shrink-0"
            aria-label="close banner"
            type="button"
            onClick={handleDismiss}
          >
            <IconClose className="tw-m-auto tw-h-6 tw-w-6 tw-text-gray-800" />
          </button>
        </div>
      </div>
    </div>
  );
};

TopBanner.propTypes = {
  header: PropTypes.string,
  content: PropTypes.string,
};

export default TopBanner;
